import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Images } from 'assets/images';
import { PASSWORD, TEXT } from 'admin/utils/contants';
import { signInScheme } from 'admin/validationSchemes/loginValidationScheme';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  LoginWrapper,
  SignInContainer,
  SignInLogo,
  TitlePage,
  SignInInput,
  SignInButton,
  SimpleSpan,
  PasswordEye,
  SignInErrors,
} from 'admin/containers/Auth/SignIn/styled';

export const SignIn = () => {
  const [isPasswordOpened, setIsPasswordOpened] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signInScheme),
  });

  const onSubmit = (data) => console.log(data);

  const openPassword = () => {
    setIsPasswordOpened((prev) => !prev);
  };

  return (
    <LoginWrapper>
      <SignInContainer onSubmit={handleSubmit(onSubmit)}>
        <SignInLogo src={Images.logo} />
        <TitlePage>Sign In</TitlePage>
        <SimpleSpan>
          <SignInInput
            placeholder="Email Address"
            {...register('email')}
            error={errors.email?.message}
          />
          <SignInErrors>{errors.email?.message}</SignInErrors>
        </SimpleSpan>

        <SimpleSpan>
          <SignInInput
            {...register('password')}
            placeholder="Password"
            type={isPasswordOpened ? TEXT : PASSWORD}
            error={errors.password?.message}
          />
          <PasswordEye
            src={
              isPasswordOpened ? Images.passwordOpenedEye : Images.passwordClosedEye
            }
            onClick={openPassword}
          />
          <SignInErrors>{errors.password?.message}</SignInErrors>
        </SimpleSpan>
        <SignInButton> Sign In </SignInButton>
      </SignInContainer>
    </LoginWrapper>
  );
};
